import { gql } from '@apollo/client';

export const GET_REPORT_HISTORY = gql`
query reports{
    reports {
        totalCount
        edges {
            node {
                id
                status
                reportType
                reportStartedAt
                reportCompletedAt
            }
        }
    }
}
`;
